import { flatten, values } from "lodash"

export const filterProductParameterGroupsByProducts = (
  productParameterGroups,
  products,
  t = undefined,
) => {
  return sortProductParameterGroups(
    productParameterGroups.filter((paramGroup) => {
      if (!products) {
        return true
      }

      return (
        products.findIndex((product) => {
          const values = product.getParamValues(paramGroup)
          return values && values.length > 0
        }) !== -1
      )
    }),
    t,
  )
}

export const filterProductParameterGroupsByProductContext = (
  productParameterGroups,
  productContext,
) => {
  return productParameterGroups.filter((paramGroup) => {
    if (
      productContext.has("market") &&
      paramGroup.parent_market &&
      +paramGroup.parent_market.id !== +productContext.get("market")
    ) {
      return false
    }
    return true
  })
}

export const filterProductsByProductContext = (products, productContext) => {
  return products.filter((product) => {
    if (
      productContext.has("market") &&
      product.markets &&
      product.markets.findIndex(
        (market) => +market.id === +productContext.get("market"),
      ) === -1
    ) {
      return false
    }
    return true
  })
}

export const filterProductParameterGroupsByProductDatabase = (
  productParameterGroups,
  productsDatabase,
) => {
  const filters = flatten(values(productsDatabase.getFilters()))

  return productParameterGroups.filter((productParamGroup) => {
    if (productParamGroup.type !== "EFFECT") {
      return true
    }
    const filter = filters.find((f) => f._id === productParamGroup.strapiId)
    return filter && !filter.isHiddenByParent()
  })
}

export const compareTwoNumericalValues = ([a1, a2], [b1, b2]) => {
  const res = a1 + a2 - (b1 + b2)

  if (res === 0) {
    return a1 - b1
  }
  return res
}

export const sortProductParameterGroups = (
  productParameterGroups,
  t = undefined,
) => {
  return productParameterGroups.sort((a, b) => {
    let res = (b.order || 0) - (a.order || 0)

    if (res === 0 && t) {
      res = t(a.name?.key || "").localeCompare(t(b.name?.key || ""))
    }

    return res
  })
}

export const sortProductsByProductParameterGroup = (
  productParameterGroup,
  products,
  t,
  ascending,
) => {
  const res = products.map((p) => p)
  res.sort((productA, productB) => {
    if (!productParameterGroup) {
      // compare by name
      return (productA.name || "").localeCompare(productB.name)
    }

    switch (productParameterGroup.type) {
      case "ENUM":
        const aValue =
          productA
            .getParamValues(productParameterGroup)
            .map((val) => t(val.value.key))
            .sort((a, b) => ("" || a).localeCompare(b))[0] || ""
        const bValue =
          productB
            .getParamValues(productParameterGroup)
            .map((val) => t(val.value.key))
            .sort((a, b) => ("" || a).localeCompare(b))[0] || ""

        return aValue.localeCompare(bValue)
      case "RANGE":
        const aRangeValue = productA.getParamValues(productParameterGroup)[0]
        const bRangeValue = productB.getParamValues(productParameterGroup)[0]

        if (!aRangeValue) return -1
        if (!bRangeValue) return 1

        return compareTwoNumericalValues(
          [aRangeValue.firstValue, aRangeValue.lastValue],
          [bRangeValue.firstValue, bRangeValue.lastValue],
        )
      case "DUAL_NUMBER":
        const aDualNumberValue = productA.getParamValues(
          productParameterGroup,
        )[0]
        const bDualNumberValue = productB.getParamValues(
          productParameterGroup,
        )[0]

        if (!aDualNumberValue) return -1
        if (!bDualNumberValue) return 1

        return compareTwoNumericalValues(
          [aDualNumberValue.value1, aDualNumberValue.value2],
          [bDualNumberValue.value1, bDualNumberValue.value2],
        )
      case "NUMBER":
        const aNumberValue = productA.getParamValues(productParameterGroup)[0]
        const bNumberValue = productB.getParamValues(productParameterGroup)[0]

        if (!aNumberValue) return -1
        if (!bNumberValue) return 1

        return aNumberValue.value - bNumberValue.value
    }
    return 0
  })

  if (!ascending) {
    res.reverse()
  }
  return res
}
